import { Subtitle } from 'modules/ui/typography/Typography';
import { mediaQuery } from 'modules/utils';
import styled from 'styled-components';

export const FormSubtitle = styled(Subtitle)`
  margin: 1rem 0;

  ${mediaQuery('md')} {
    margin: 2rem 0;
  }
`;
